/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";
import { withParamsAndNavigate } from "../components/WithParamsAndNavigate";
import BaseCom from "../components/BaseCom";
import "./UDHSOnboarding.css";
import L from "../components/Lang";
import { ErrorAlertModal } from "../components/ErrorAlertModal";
import countries from "../dicts/countries.json";
import statesUSA from "../dicts/states-usa.json";
import statesCanada from "../dicts/states-canada.json";
import FormInput from "../components/FormInput";

class UDHSOnboarding extends BaseCom {
    moduleList = [
        ["WMS", "Electronic Health Record", "Scheduling, encounters, providers, and patient visits."],
        ["LIS", "Laboratory Information System", "Orders, specimens, results, and LIS workflows."],
        ["MNF", "Logistics", "Medical devices, logistics, manufacturing."],
        ["GEN", "Company Hub", "Workflows and company operations."]
    ];

    constructor(props) {
        super(props);

        this.state = {
            step: 0,
            organizationName: "",
            organizationType: "clinic",
            adminName: "",
            adminEmail: "",
            adminPhone: "",
            region: "Puerto Rico",
            modules: {
            },
            otp: {},
            acceptTerms: false
        };
    }

    setValue = (e) => {
        const { name, value, type, checked } = e.target;

        this.setState({
            [name]: type === "checkbox" ? checked : value
        });
    };

    toggleModule = (key) => {
        const modules = { ...this.state.modules };
        for (let k in modules) {
            modules[k] = false;
        }
        modules[key] = true;
        this.setState({ modules: modules });
    };

    next = () => {
        if (this.state.step === 1) {
            console.log('step3');
            // trigger point
        }
        if (this.state.step === 1) {
            let ok = false;
            for (var k in this.state.modules) {
                if (this.state.modules[k])
                    ok = true;
            }
            if (!ok) {
                this.alert(<L>Please select one of the modules.</L>);
                return;
            }
        }
        this.setState({
            step: Math.min(this.state.step + 1, 3)
        });
    };

    back = () => {
        this.setState({
            step: Math.max(this.state.step - 1, 0)
        });
    };

    finish = () => {
        const data = {
            organizationName: this.state.organizationName,
            organizationType: this.state.organizationType,
            adminName: this.state.adminName,
            adminEmail: this.state.adminEmail,
            adminPhone: this.state.adminPhone,
            region: this.state.region,
            modules: this.state.modules,
            acceptTerms: this.state.acceptTerms
        };

        if (this.props.onComplete) {
            this.props.onComplete(data);
        }
    };

    renderStepIndicator() {
        const steps = ["Organization", "Modules", "Validation", "Review"];

        return (
            <div className="UDHSOnboarding-steps">
                {steps.map((title, index) => (
                    <div
                        key={title}
                        className={`UDHSOnboarding-step ${this.state.step === index ? "active" : ""} ${this.state.step > index ? "done" : ""}`}
                    >
                        <div className="UDHSOnboarding-stepNumber">{index + 1}</div>
                        <span>{title}</span>
                    </div>
                ))}
            </div>
        );
    }

    renderOrganizationStep() {
        return (
            <div className="UDHSOnboarding-card">
                <h2>Tell us about your organization</h2>
                <p>This information helps us configure your UDHS workspace correctly.</p>

                <div className="row g-3 mt-2">
                    <div className="col-md-6">
                        <label className="form-label">Organization Name</label>
                        <input
                            className="form-control"
                            name="organizationName"
                            value={this.state.organizationName}
                            onChange={this.setValue}
                            placeholder="Example: San Juan Medical Group"
                            required
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Organization Type</label>
                        <select
                            className="form-select"
                            name="organizationType"
                            value={this.state.organizationType}
                            onChange={this.setValue}
                            required
                        >
                            <option value="clinic">Clinic</option>
                            <option value="laboratory">Laboratory</option>
                            <option value="hospital">Hospital</option>
                            <option value="imaging-center">Imaging Center</option>
                            <option value="other">Other</option>
                        </select>
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Primary Admin Name</label>
                        <input
                            className="form-control"
                            name="adminName"
                            value={this.state.adminName}
                            onChange={this.setValue}
                            placeholder="Full name"
                            required
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Admin Email</label>
                        <input
                            type="email"
                            className="form-control"
                            name="adminEmail"
                            value={this.state.adminEmail}
                            onChange={this.setValue}
                            placeholder="admin@example.com"
                            required
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Admin Phone</label>
                        <input
                            className="form-control"
                            name="adminPhone"
                            value={this.state.adminPhone}
                            onChange={this.setValue}
                            placeholder="(787) 000-0000"
                            required
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Country</label>
                        <select
                            className="form-control"
                            name="country"
                            value={this.state.country}
                            onChange={this.setValue}
                            required>
                            {countries.list.map((i, idx) => <option key={idx} value={i.id}>{i.name}</option>)}
                        </select>
                    </div>
                </div>
            </div>
        );
    }

    renderModulesStep() {


        return (
            <div className="UDHSOnboarding-card">
                <h2>Select the type of service you need</h2>
                <p>Choose the UDHS module your organization wants to start with.</p>

                <div className="UDHSOnboarding-moduleGrid mt-3">
                    {this.moduleList.map(([key, title, description]) => (
                        <button
                            key={key}
                            type="button"
                            className={`UDHSOnboarding-module ${this.state.modules[key] ? "selected" : ""}`}
                            onClick={() => this.toggleModule(key)}
                        >
                            <div>
                                <strong>{title}</strong>
                                <span>{description}</span>
                            </div>

                            <div className="UDHSOnboarding-check">
                                {this.state.modules[key] ? "✓" : ""}
                            </div>
                        </button>
                    ))}
                </div>
            </div>
        );
    }

    renderValidationStep = () => {
        return (
            <div className="UDHSOnboarding-card">
                <h2>Validation</h2>
                <p>We must validate your email and phone before loading an instance.</p>

                <div className="UDHSOnboarding-securityList">
                    <FormInput model={this.state.otp} name="emailCode" placeholder="XXXXXX" label="Email Code" />
                    <FormInput model={this.state.otp} name="phoneCode" placeholder="XXXXXX" label="Phone Code" />
                </div>
            </div>
        );
    }

    renderReviewStep() {
        const enabledModules = Object.keys(this.state.modules).filter((key) => this.state.modules[key]);


        var mod = this.moduleList.find(x => x[0] === enabledModules[0]);


        return (
            <div className="UDHSOnboarding-card">
                <h2>Ready to create your workspace?</h2>
                <p>Review your information and accept the terms to continue.</p>

                <div className="UDHSOnboarding-review">
                    <div>
                        <span>Organization</span>
                        <strong>{this.state.organizationName || "Not set"}</strong>
                    </div>

                    <div>
                        <span>Organization Type</span>
                        <strong>{this.state.organizationType}</strong>
                    </div>

                    <div>
                        <span>Primary Admin</span>
                        <strong>{this.state.adminName || "Not set"}</strong>
                    </div>

                    <div>
                        <span>Admin Email</span>
                        <strong>{this.state.adminEmail || "Not set"}</strong>
                    </div>

                    <div>
                        <span>Admin Phone</span>
                        <strong>{this.state.adminPhone || "Not set"}</strong>
                    </div>

                    <div>
                        <span>Region</span>
                        <strong>{this.state.region}</strong>
                    </div>
                </div>

                <div className="UDHSOnboarding-tags">
                    <span key={mod[1]}>{mod[1]}</span>
                </div>

                <label className="UDHSOnboarding-terms">
                    <input
                        type="checkbox"
                        name="acceptTerms"
                        checked={this.state.acceptTerms}
                        onChange={this.setValue}
                    />
                    <span>
                        I agree to the UDHS terms of service, privacy policy, and authorized-use requirements.
                    </span>
                </label>
            </div>
        );
    }

    renderCurrentStep() {
        switch (this.state.step) {
            case 0:
                return this.renderOrganizationStep();
            case 1:
                return this.renderModulesStep();
            case 2:
                return this.renderValidationStep();
            case 3:
                return this.renderReviewStep();
            default:
                return null;
        }
    }

    isLast = () => {
        return this.state.step === 3;
    }

    submit = (e) => {
        e?.preventDefault();
        if (this.isLast())
            this.finish();
        else
            this.next();
    }

    render() {
        const isLast = this.state.step === 3;

        return (
            <div className="UDHSOnboarding">
                <ErrorAlertModal />
                <div className="UDHSOnboarding-shell">
                    <form onSubmit={this.submit}>
                        <div className="UDHSOnboarding-header">
                            <div>
                                <span className="UDHSOnboarding-eyebrow">UDHS Signup</span>
                                <h2>Create your UDHS workspace</h2>
                                <p>Start your secure healthcare environment in a few guided steps.</p>
                            </div>

                            <div className="UDHSOnboarding-status">
                                <span>Self-Service</span>
                            </div>
                        </div>

                        {this.renderStepIndicator()}

                        {this.renderCurrentStep()}

                        <div className="UDHSOnboarding-actions">
                            <button
                                type="button"
                                className="btn btn-outline-light"
                                onClick={this.back}
                                disabled={this.state.step === 0}
                            >
                                Back
                            </button>

                            {!this.isLast() && (
                                <button type="submit" className="btn UDHSOnboarding-primary">
                                    Continue
                                </button>
                            )}

                            {this.isLast() && (
                                <button
                                    type="submit"
                                    className="btn UDHSOnboarding-primary"
                                    disabled={!this.state.acceptTerms}
                                >
                                    Create My UDHS Instance
                                </button>
                            )}
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export default withParamsAndNavigate(UDHSOnboarding);